<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication" style="margin-top:3em;">For Jennifer Brimer and David Reines </p>
<p class="ORIM-Dedication">My cherished friends</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-1.vue?7fa6823f